import { AxiosInstance } from "axios";
import { Result } from "services/Result";
import { ISystemProvider } from "interfaces/providers/ISystemProvider";
import { ISystemData } from "pages/Map/components/interfaces";

// @injectable()
export class SystemApiService implements ISystemProvider {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getSystems = async () => {
    let response = await this.axiosInstance.get<Result<ISystemData[]>>(
      "api/system"
    );
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error("Failed to fetch systems: " + response.status);
  };
}
